import resellersModule from "../resellersModule.js";

function resaleService(resellersConstants, $q, $filter, httpService) {
    "ngInject";

    return {
        getAssetResaleData: function (assetId) {
            var config = {
                url: $filter("formatString")(resellersConstants.urls.getResaleData, { assetId: assetId })
            };

            return $q(function (resolve, reject) {
                return httpService.httpGet(config, {}).then(function (r) {
                    resolve(r);
                }).catch(httpService.getApiErrorCodeHandler(reject, resellersConstants.errorCodes.economyApi));
            });
        }
    };
}

resellersModule.factory("resaleService", resaleService);
export default resaleService;